module.exports = fox._r("images/offer/acp/freeacp/bbw/overlay-small.jpg", __webpack_public_path__ + "_/_/_/root/images/offer/acp/freeacp/bbw/overlay-small.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/offer/acp/freeacp/bbw/overlay-small.jpg
// module id = 203
// module chunks = 4